import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices, useUploadImage } from 'hook/services'
import { useAgencyInfo } from 'context/agency'
import { FormControl, InputLabel, MenuItem, Select, TextareaAutosize } from '@mui/material'
import Editor from 'components/editor'

const CreateModal = ({ handleRefresh }) => {
  const uploadImage = useUploadImage()

  const [agency] = useAgencyInfo()
  const AppService = useAppServices()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const [processing, setProcessing] = useState(false)
   const [description,setDescription] = useState('')

  // console.log(svgIcon, "svgIcon")
  const handleModal = () => {
    setOpenAddProduct(true)
  }

  const closeAddProduct = () => {
    setOpenAddProduct(false)
  }


  const handleSubmit = async (e) => {

    e.preventDefault();
    setProcessing(true);

    const formData = new FormData(e.target);
    const answerValue = formData.get("public") === "true";
    const payload = {
      name: e.target.name.value,
      description,
      date: e.target.date.value, // Store the uploaded image URL
      feature: e.target.feature.value,
      type: e.target.type.value,
      public: answerValue,
    };

    console.log(payload, "payload");
    // return

    const { response } = await AppService.changelogs.create({ payload });

    if (response) {
      setProcessing(false);
      closeAddProduct();
      handleRefresh();
    }
  };


  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 612,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <MDButton color="white" variant="contained" onClick={handleModal}>
        Create
      </MDButton>
      <MDModal open={openAddProduct} onClose={closeAddProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style} >
            <MDTypography variant="h5" mb={2}>
              Create Changelogs
            </MDTypography>

            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="Name" name="name" fullWidth required />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Description</MDTypography>
              <Editor handleChange={setDescription} />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Public</MDTypography>
              <FormControl fullWidth>
                <InputLabel>Public</InputLabel>
                <Select name="answer" defaultValue="">
                  <MenuItem value="true">True</MenuItem>
                  <MenuItem value="false">False</MenuItem>
                </Select>
              </FormControl>
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Type</MDTypography>
              <MDInput
                select
                name="type"
                fullWidth
                required
                SelectProps={{ native: true }}
              >
                <option value="LevelUpMarketPlace">LevelUpMarketPlace</option>
                <option value="Location">Location</option>
                <option value="Agency">Agency</option>
                <option value="appcreator">Appcreator</option>

              </MDInput>
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">feature</MDTypography>
              <MDInput label="feature" name="feature" fullWidth />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Date</MDTypography>
              <MDInput label="Date" name="date" type="date" fullWidth defaultValue={new Date().toISOString().split("T")[0]} />

            </MDBox>




            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeAddProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default CreateModal
